import {convertObjectToMap} from "./views/ProfiliOrari/Utility/commonFunctions";
import {saveAs} from 'file-saver';
import {TAB_ENUM_INDIVIDUI_TARGET, TIPO_INDIVIDUO} from "./costanti";
import {dayJS} from "./applicationConf";

export const utilityFunction = (dataInizio, dataFine = dayJS().format('YYYY-MM-DD')) => {
    let dateStart, dateEnd;
    const __periodo = [];

    switch (true) {
        case dayJS().isBefore(dataFine) && dayJS().isAfter(dataInizio) :
        case dayJS().isAfter(dataFine) : {
            dateStart = dayJS(dayJS(dataInizio).format('YYYY-M-D'));
            dateEnd = dayJS(dayJS(dataFine).format('YYYY-M-D'));
            break;
        }
        case dayJS().isBefore(dayJS(dataInizio)) && (dataFine == null || dayJS().isSame(dataFine)): {
            dateStart = dayJS(dayJS(dataInizio).format('YYYY-M-D'));
            dateEnd = dayJS(dayJS(dataInizio).format('YYYY-M-D'));
            break;
        }
        default :
            dateStart = dayJS(dataInizio != null ? dayJS(dataInizio).format('YYYY-M-D') : dayJS().format('YYYY-MM-DD'));
            dateEnd = dayJS(dataFine != null ? dayJS(dataFine).format('YYYY-M-D') : dayJS().format('YYYY-MM-DD'));
            break;
    }

    while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
        __periodo.push(dateStart.isSame(dayJS(dataInizio)) ?
            dayJS(dataInizio).format('YYYY-M-D') :
            dayJS(`${dayJS(dateStart, 'YYYY-M-D').format('YYYY')}/${dayJS(dateStart, 'YYYY-M-D').format('M')}`, 'YYYY/M').startOf('month').format('YYYY-M-D'));
        dateStart = dateStart.add(1, 'month');
    }

    return __periodo;
};

//obj per la creazione della dropDownList dei docenti/allievi
export const listaIndividui = (individui) => {
    const _individui = [];

    individui.map((c) => _individui.push(
            {
                value: c.idAnagrafica,
                displayValue: c.cognome.charAt(0).toUpperCase() + c.cognome.slice(1).toLowerCase() + ' ' + c.nome.charAt(0).toUpperCase() + c.nome.slice(1).toLowerCase()
            }
        )
    );
    return _individui;
};

//obj per la creazione della dropDownList delle attività
export const listaAttivita = (attivita) => {
    const blacklist = ['ORIENTAMENTO_INDIVIDUALE', 'FAD', 'STAGE']
    const _attivita = [];
    
    attivita.map((c) => blacklist.includes(c.codice) ? null : _attivita.push({
        value: c.id,
        displayValue: c.descrizione.charAt(0).toUpperCase() + c.descrizione.slice(1).toLowerCase()
    }));
    return _attivita;
};

//obj per la creazione della dropDownList delle unitaFormative
/**
 * @param {Array} unitaFormative array of the unita formative recovered from the professor recovered by id of the course in object
 * */
export const listaUnitaFormative = (unitaFormative) => {
    const _unitaFormative = [];

    unitaFormative.map(uf => _unitaFormative.push({
        value: uf.id,
        displayValue: uf.descrizione.charAt(0).toUpperCase() + uf.descrizione.slice(1).toLowerCase()
    }));
    return _unitaFormative;
};

//aggiunta di un oggetto in un array se non esiste
export const addIfNotExists = (newArray, value, serchingArray, field) => {
    const temp = [];

    if (!newArray) {
        temp.push(Object.assign({}, serchingArray.filter(a => a[field] === value)[0]));
        return temp;
    } else if (newArray.includes(serchingArray.filter(a => a[field] === value)[0][field])) {
        return newArray;
    } else {
        newArray.push(Object.assign({}, serchingArray.filter(a => a[field] === value)[0]));
        return newArray;
    }

};

export const removeItemArray = (array, value, field) => {
    const index = array.map(obj => obj[field]).indexOf(value);
    array.splice(index, 1);
    return array.length > 0 ? array : []
};

//controllo data con date corso
export const checkDate = (data, objDataCorsoTarget) => {

    if (objDataCorsoTarget.dataTarget != null && dayJS(objDataCorsoTarget.dataTarget, 'YYYY-MM-DD').isSame(dayJS(data, 'YYYY-MM'), 'month')) {

        return dayJS(objDataCorsoTarget.dataTarget, 'YYYY-MM-DD').format('YYYY-MM-DD')
    } else {
        switch (objDataCorsoTarget.id) {
            case 'dataInizio' : {
                return dayJS(data).startOf('month').format('YYYY-MM-DD');
            }
            case 'dataFine' : {
                return dayJS(data, 'YYYY-MM').isSame(dayJS().format('YYYY-MM'), 'month') ?
                    dayJS().format('YYYY-MM-DD') : dayJS(data).endOf('month').format('YYYY-MM-DD');
            }
            default :
                return null;
        }
    }
};

export function printOnlyInDevelopment(message, ...values) {
    if (process.env.NODE_ENV === 'development') {
        console.log(message, ...values);
    }
}

// gestione Errore
export const handlerErrorRedirect = (error, navigate) => {
    if (error != null && error.response != null) {
        navigate({
            pathname: '/error',
            state: {
                status: error.response.status,
                message: error.response.statusText
            }
        })
    } else {
        navigate({
            pathname: '/error',
            state: {
                status: null,
                message: error?.message
            }
        })
    }
};

// funzione per controllare se l'oggetto passato è un'istanza di Map per i propTypes

export function isMapObject(propValue, key, componentName, location, propFullName) {
    const modelGiornaliero = {
        orarioEntrata: null,
        orarioUscita: null,
        deltaFlessibilitaEntrataPre: null,
        deltaFlessibilitaEntrataPost: null,
        deltaFlessibilitaUscitaPost: null,
        deltaFlessibilitaUscitaPre: null,
        tempo: null,
        minimoNumeroTimbrature: null,
        pausa: null
    };

    const mapGiornaliero = convertObjectToMap(propValue);

    if (!(mapGiornaliero instanceof Map)) {
        return new Error(`The field giornaliero provided from ${componentName} is not a instance of Map. Path :: ${propFullName}`);
    }

    const modelGiornalieroKeys = Object.keys(modelGiornaliero).sort();
    const valueKeys = Object.keys(propValue[key]).sort();

    if (!(JSON.stringify(modelGiornalieroKeys) === JSON.stringify(valueKeys))) {
        return new Error(`The field giornaliero provided from ${componentName} is not a instance of Map. Path :: ${propFullName}`);
    }
}


export function createMessageRequestException(error) {
    let message;

    if (typeof error === 'string') {
        return error;
    }

    if (error.response) {
        const e = error.response.data;
        if (typeof e === 'string') {
            if (e.startsWith('it') || e.startsWith('java')) {
                if (e.split(':').length === 2) {
                    message = e.split(':').splice(1).map(s => s.trim());
                } else {
                    message = e;
                }
            } else if (e.includes('<!DOCTYPE html>')) {
                message = `${error.response.status} - ${error.response.statusText}`;
            } else {
                message = e;
            }
        } else if (typeof e === 'object') {
            message = Object.keys(e).map(key =>
                `${key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()} : ${
                    Array.isArray(e[key]) ?
                        e[key].length > 1 ?
                            e[key].join(', ') :
                            e[key] :
                        e[key]
                }`);
        } else {
            printOnlyInDevelopment(error.response);
            message = 'Errore Generico';
        }
    } else {
        message = error.message;
    }
    return message;
}

// funzione ricalcolo expireIn token per richiederne uno nuovo per dello scadere della sessione
export const recalculationExpireInToken = (expiresIn) => {
    // tolgo 5 secondi al timestamp inviato con il token
    //const newExpireIn = moment(moment.unix(expiresIn)).subtract(5, 'seconds').format('x');
    const newDateJS= dayJS(expiresIn*1000).subtract(5, 'seconds');

    // calcolo il tempo in millisecondi c'è dal momento in cui ho ricevuto il token alla nuova scadenza
    //const diff = moment.duration(moment(moment.unix(+newExpireIn / 1000), 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'YYYY-MM-DD HH:mm:ss'));

    // return diff.asMilliseconds();
    return newDateJS.diff(dayJS(), 'milliseconds');
};

// funzione per la conversione del base64 in blob e download automatico
export function convertBase64ToBlob(dataStream, fileName) {
    let base64, mimeType;

    if (dataStream.split(',').length > 1) {
        base64 = dataStream.split(',')[1];
        mimeType = dataStream.split(',')[0].split(':')[1].slice(0, -7);
    } else {
        base64 = dataStream;
    }

    const byteCharacters = atob(base64);

    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: mimeType});

    saveAs(blob, fileName, {autoBom: true});

}

// funzione per controllare se un allievo si è ritirato
export const isRitirato = (corso, idAnagrafica, currentMonth) => {
    const individuo = corso[TAB_ENUM_INDIVIDUI_TARGET[TIPO_INDIVIDUO.ALLIEVI].propCorso].find(individuo => individuo.idAnagrafica === idAnagrafica);
    return individuo != null && dayJS(individuo.dataFinePartecipazione, 'YYYY-MM-DD').isBefore(dayJS(currentMonth, 'YYYY-MM'), 'month');
}

// funzione per controllare se un docente non è in incarico
export const isDocenteFuoriIncarico = (corso, idAnagrafica, currentMonth) => {
    const docente = corso[TAB_ENUM_INDIVIDUI_TARGET[TIPO_INDIVIDUO.DOCENTI].propCorso].find(doc => doc.idAnagrafica === idAnagrafica);
    if (!docente) return false;
    
    const month = dayJS(currentMonth, 'YYYY-MM');
    const dataInizio = docente.dataInizioIncarico ? dayJS(docente.dataInizioIncarico, 'YYYY-MM-DD') : null;
    const dataFine = docente.dataFineIncarico ? dayJS(docente.dataFineIncarico, 'YYYY-MM-DD') : null;
    
    if (dataInizio && month.isBefore(dataInizio, 'month')) return true;
    if (dataFine && month.isAfter(dataFine, 'month')) return true;
    
    return false;
}

export const isRitiratoForGraphics = (corso, idAnagrafica, currentMonth) => {
    const individuo = corso[TAB_ENUM_INDIVIDUI_TARGET[TIPO_INDIVIDUO.ALLIEVI].propCorso].find(individuo => individuo.idAnagrafica === idAnagrafica);
    return individuo != null && dayJS(individuo.dataFinePartecipazione, 'YYYY-MM-DD').isSameOrBefore(dayJS(currentMonth, 'YYYY-MM'), 'month');
}


export const encodeUnicode = (str) => {
    return btoa(encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        (match, rgx_result) => String.fromCharCode(Number('0x' + rgx_result))));
}

export const isPwa = () => {
    return window.matchMedia('(display-mode: standalone)').matches;
}

export function capitalizeFirstLetter(str) {
    return String(str).charAt(0).toUpperCase() + String(str).slice(1);
}